import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DependencyLicenseModel } from '../models';
import { DependencyLicenseEndpoint } from '../constants/dependency-license.endpoint';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';

@Injectable({
  providedIn: 'root',
})
export class DependencyLicenseListService {
  constructor(private http: WrapperHttpService) {}

  getDependencyLicenseList(): Observable<DependencyLicenseModel[]> {
    const url = `${DependencyLicenseEndpoint.Base}`;
    return this.http.withLoading().get<DependencyLicenseModel[]>(url);
  }
}
